<template>
  <div class="season-dialog">
    <el-dialog title="基础信息" :visible="true" width="60%" :show-close="false">
      <div class="content">
        <div class="basis">
          <div class="row">
            <span>赛季名称：</span>
            <div class="control">
              <el-input
                :disabled="allDisabled"
                :maxlength="10"
                size="small"
                type="text"
                v-model="name"
                placeholder="请输入赛季名称"
              ></el-input>
            </div>
          </div>

          <div class="row">
            <span>选择赛季周期：</span>
            <div class="control">
              <el-date-picker
                :disabled="allDisabled"
                v-model="seasonCycle"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>

          <div class="row">
            <span>赛季标题图片上传：</span>
            <div class="control">
              <el-upload
                :action="uploadHost"
                :data="uploadData"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :disabled="allDisabled"
              >
                <img v-if="img" :src="img" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
        </div>

        <div class="rule">
          <div class="title">规则设置</div>

          <div class="row">
            <span>PK失败是否掉段位：</span>
            <div class="control">
              <el-radio-group v-model="pkFailType" :disabled="allDisabled">
                <el-radio :label="1">不掉段位</el-radio>
                <el-radio :label="2">掉段位</el-radio>
              </el-radio-group>
            </div>
          </div>

          <div class="row" v-show="pkFailType === 2">
            <span>请输入减少段位数量：</span>
            <div class="control">
              <el-input-number
                :disabled="allDisabled"
                v-model="failGradeNum"
                :min="1"
                :max="5"
                label="请输入数字"
                size="small"
              ></el-input-number>
            </div>
          </div>
        </div>
      </div>

      <div class="footer">
        <el-button size="small" @click="handleClose(0)">取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="handleSave"
          :disabled="allDisabled"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import * as API from "@/api/season/vip.js";
import { oss } from "@/libs/uploadFile";
import { getpublicImgUrl } from "@/api/base/api-upload";

export default {
  props: ["defaultData", "handleClose", "openType"],
  data() {
    const { name, beginDate, endDate, img, pkFailType, failGradeNum } =
      this.defaultData;
    return {
      name,
      seasonCycle: beginDate && endDate ? [beginDate, endDate] : null,
      img,
      pkFailType: pkFailType ?? 2,
      failGradeNum: failGradeNum ?? 1,
      allDisabled: beginDate
        ? dayjs().valueOf() < dayjs(beginDate).valueOf()
          ? false
          : true
        : false,
      uploadHost: "",
      uploadData: {},
      fileData: {
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
    };
  },
  methods: {
    handleAvatarSuccess(res) {
      this.uploadRes = res;
      // 获取公有链接
      getpublicImgUrl(this.fileData.fileName).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          this.fileData.fileUrl = res.data;
          this.fileData.name = this.fileData.fileName;
          this.fileData.url = res.data;
          this.img = data;
        } else {
          this.$message.error("获取图片链接失败");
        }
      });
    },
    async beforeAvatarUpload(file) {
      const imgTypeList = ["image/jpeg", "image/jpg", "image/png"];
      const { name, size, type } = file;
      if (!imgTypeList.includes(type)) {
        this.$message.warning("只能上传jpeg、jpg、png格式图片");
        return;
      }
      if (size / 1024 / 1024 > 1) {
        this.$message.warning("只能上传小于1M图片");
        return;
      }

      const isSize = await this.limitFileWH(1756, 184, file);

      if (isSize) {
        return oss(name, 0, "public/product/").then((res) => {
          this.uploadHost = res.host;
          this.uploadData = res;
          this.fileData.fileName = res.key;
          this.fileData.oFileName = file.name;
          this.fileData.fileUrl = res.key;
        });
      }
    },
    limitFileWH(maxWidth, maxHeight, file) {
      const isSize = new Promise(function (resolve, reject) {
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.onload = function () {
          const valid = img.width <= maxWidth && img.height <= maxHeight;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return true;
        },
        () => {
          this.$message.warning("图片超出推荐尺寸：推荐尺寸: 1756px * 184px");
          return false;
        }
      );
      return isSize;
    },
    async handleSave() {
      const { name, seasonCycle, img, pkFailType, failGradeNum } = this;
      const [beginDate, endDate] = (seasonCycle ?? []).map((item) =>
        dayjs(item).format("YYYY-MM-DD")
      );
      if (!(name && beginDate && endDate && img)) {
        this.$message.warning("全部为必填项，缺一不可!");
        return;
      }
      const params = {
        beginDate,
        endDate,
        failGradeNum: String(failGradeNum),
        img,
        name,
        pkFailType: String(pkFailType),
      };
      try {
        const res =
          this.openType === "add"
            ? await API.addSeason(params)
            : await API.updateSeason(params, this.defaultData.id);
        const { code } = res;
        if (code === 0) {
          this.$message.success("保存成功");
          this.handleClose(this.openType === "add" ? 1 : 2);
        }
      } catch (error) {
        //request已提示
      }
    },
  },
};
</script>
<style scoped lang="scss">
.season-dialog {
  .content {
    .basis,
    .rule {
      > .title {
        line-height: 24px;
        font-size: 18px;
        color: #303133;
        margin-bottom: 50px;
      }
      .row {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        > span {
          width: 230px;
          text-align: right;
        }
        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 300px;
          height: 100px;
          line-height: 100px;
          text-align: center;
          background: rgb(244, 245, 245);
        }
        .avatar {
          width: 300px;
          height: 100px;
          display: block;
        }
      }
    }
  }
  .footer {
    text-align: right;
  }
}
</style>
